import React from "react";
import { Navigate } from "react-router-dom";

import { routingConstants } from "../Constants/routingConstants";
import { getLocalStorageState, _localGet } from "../localStorage";
const PublicRoute = ({ children }) => {
  let data = null;
  if (_localGet("state")) {
    data = getLocalStorageState();
  }

  if (data == null) {
    return children;
  }
  let isAuthenticated = data?.session?.isAuthenticated
    ? data.session.isAuthenticated
    : false;
  let token = data ? data?.session?.session?.user_token : null;
  // console.log("token", token, "isAuthenticated", isAuthenticated);
  if (token && isAuthenticated) {
    return <Navigate to={routingConstants.dashboard} />;
  }
  return children;
};

export default PublicRoute;
